import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { fastCheckoutActions } from '@/redux/modules';

const useFastCheckoutNavigation = (routeOriginInfo, routesLocale) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleBackNavigation = useCallback(() => {
    history.goBack();
    dispatch(fastCheckoutActions.reset());
  }, [history, dispatch]);

  const handleNavigateAfterSuccess = useCallback(() => {
    const onSuccessInfo = routeOriginInfo && routeOriginInfo.onSuccess;
    const finishRoute = onSuccessInfo && onSuccessInfo.route;
    const routeParams = onSuccessInfo && onSuccessInfo.state;
    history.push(finishRoute || routesLocale.fastcheckout, { ...routeParams });
  }, [history, routesLocale.fastcheckout, routeOriginInfo]);

  return {
    handleBackNavigation,
    handleNavigateAfterSuccess,
  };
};

export default useFastCheckoutNavigation;
